import React from 'react';

import { longanDispatchError } from '@fx/longan-sdk';

class ErrorBoundary extends React.Component {
  public componentDidCatch(error: any, info: any) {
    // 错误上报
    try {
      longanDispatchError({
        error_message: error.toString(),
        error_content: error.stack,
        error_level: '1',
        error_tag: 'error_boundary',
      });
    } catch (err) {
      console.log(err);
    }
  }

  public render() {
    return this.props.children;
  }
}
export default ErrorBoundary;
